export const ConstantOverrides = {};



// WEBPACK FOOTER //
// ./src/model-registry/overrides/constant-overrides.js